import $ from 'jquery';
import respImg from '../modules/responsiveImages';
import lazyLoad from '../modules/lazyLoad';

$.fn.initImages = function() {
    var el = $(this);
    respImg.initEl(el);
    lazyLoad.init(el);
};
